@if (isHeader || !cistern) {
  <th class="icon-cell"></th>
  <th>{{ 'cisterns.list.name' | translate }}</th>
  <th>{{ 'cisterns.list.fillLevel' | translate }}</th>
  <th>{{ 'cisterns.list.volume' | translate }}</th>
  <th>{{ 'cisterns.list.capacity' | translate }}</th>
  <th class="icon-cell"></th>
} @else {
  <td class="icon-cell">
    <app-icon name="ic_cistern"/>
  </td>
  <th>{{ cistern.name }}</th>
  <td>{{ (cistern.currentWaterPercentage ?? 0) / 100 | localizedPercent:'1.0-0' }}</td>
  <td>{{ cistern.currentWaterVolume ?? 0 | localizedNumber:'1.0-0' }} l</td>
  <td>{{ cistern.literCapacity ?? 0 | localizedNumber:'1.0-0' }} l</td>
  <td class="icon-cell">
    <app-context-menu [menuItems]="contextMenu"/>
  </td>
}
